
<div ref="container" class="vue-horizontal-list">
  <!-- Modifications LQ: ajout condition affichage des chevrons -->
  <div
    v-if="width.window > _options.navigation.start && jel_isEcranDesktop($mq)"
    class="vhl-navigation"
  >
    <div v-if="_hasPrev" class="vhl-btn-left" @click="prev">
      <slot name="nav-prev">
        <svg :fill="_options.navigation.color" width="32px" height="32px" viewBox="0 0 24 24">
          <path
            d="M10.757 12l4.95 4.95a1 1 0 1 1-1.414 1.414l-5.657-5.657a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 0 1 1.414 1.414L10.757 12z"
          />
        </svg>
      </slot>
    </div>

    <div v-if="_hasNext" class="vhl-btn-right" @click="next">
      <slot name="nav-next">
        <svg :fill="_options.navigation.color" width="32px" height="32px" viewBox="0 0 24 24">
          <path
            d="M13.314 12.071l-4.95-4.95a1 1 0 0 1 1.414-1.414l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"
          />
        </svg>
      </slot>
    </div>
  </div>

  <!-- Modifications LQ - Ajout de classes css -->
  <div
    class="vhl-container"
    :class="[
      { 'w-100 m-0': options.isCarteListeUnElement },
      options.classeCssConteneur,
      `vhl-${_size}-cartes`,
    ]"
    :style="_style.container"
  >
    <!-- Modifications LQ - Ajout de classes css -->
    <div
      ref="list"
      class="vhl-list"
      :class="options.isCarteListeUnElement ? 'pl-5 pl-xl-6 pr-2' : _options.list.class"
      :style="_style.list"
      @scroll="scrollHandler"
    >
      <!-- Modifications LQ  -->
      <!-- - Ajout d'un :key pour éviter une erreur :
      Elements in iteration expect to have 'v-bind:key' directives -->
      <!-- Ajout de classes css -->
      <div
        v-for="item in _items"
        ref="item"
        :key="item.id"
        class="vhl-item"
        :class="[
          _options.item.class,
          { 'w-100 px-0': options.isCarteListeUnElement },
          $isMobile() ? 'pb-4' : 'pb-2',
        ]"
        :style="_style.item"
      >
        <slot v-if="item.type === 'start'" name="start"></slot>
        <slot v-else-if="item.type === 'end'" name="end"></slot>
        <slot v-else-if="item.type === 'item'" :item="item.item">{{ item }}</slot>
      </div>

      <div :style="_style.tail"></div>
    </div>
  </div>
</div>
